import { render, staticRenderFns } from "./CampaignDetail.vue?vue&type=template&id=7313b7b0&"
import script from "./CampaignDetail.vue?vue&type=script&lang=js&"
export * from "./CampaignDetail.vue?vue&type=script&lang=js&"
import style0 from "./CampaignDetail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports